import { formatClockTime, formatMoney, formatStayDate, toCents } from '@brandonstrong/utils';

export const money = (value: string | number): string =>
  formatMoney(typeof value === 'number' ? value : toCents(value));

export const stayDate = (iso: string): string => formatStayDate(iso);

/** "15:00" -> "3:00 PM": hotel times the way guests read them. */
export const clockTime = (value: string): string => formatClockTime(value);

export const shortDate = (iso: string): string =>
  formatStayDate(iso, { month: 'short', day: 'numeric' });

export const dateTime = (iso: string): string =>
  new Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeStyle: 'short' }).format(
    new Date(iso),
  );

export const plural = (n: number, word: string): string => `${n} ${word}${n === 1 ? '' : 's'}`;
